import { render, staticRenderFns } from "./OurWorkDetails.vue?vue&type=template&id=c72938fc&"
import script from "./OurWorkDetails.vue?vue&type=script&lang=js&"
export * from "./OurWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports